import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import ListingCard from '../../Shared/ListingCard'
import { isPresent } from '../../../lib/utils/collection'
import SimpleSlider from '../../Shared/SimpleSlider'
import { invokeAction } from '../../../lib/globalActions'
import { Spinner } from '../../../shared_components/Svg'

const sliderSettings = {
  speed: 250,
  loop: true,
  items: 2,
  slideBy: 1,
  nav: true,
  navAsThumbnails: true,
  gutter: 20,
  lazyload: true,
  controls: true,
  responsive: {
    320: {
      items: 1,
      gutter: 15,
      edgePadding: 1
    },
    767: {
      items: 2,
      gutter: 15,
      edgePadding: 1
    },
    1025: {
      items: 2,
      gutter: 20,
      edgePadding: 0
    }
  }
}

const TrendingSlider = ({ listings, markListingAsSaved, isLoading }) => {
  const onSaveHandler = listing => e => {
    e.stopPropagation()
    e.preventDefault()
    invokeAction('SearchResultsMap', 'updateSaveStatus', listing)
    markListingAsSaved(listing.id)
  }

  return (
    <Fragment>
      { (isPresent(listings) && !isLoading) ? (
        <SimpleSlider
          wrapperClassName='SimpleSlider-wrapper--impressionCards'
          controlsClassName='SimpleSlider-controls--impressionCards'
          settings={sliderSettings}
          ariaLabel='Stories'
        >
          { listings.map((listing, i) => (
            <ListingCard
              key={listing.id}
              listing={listing}
              onSave={onSaveHandler(listing)}
              wrapperCalssName='ListingCard-forSlider'
              isEagerLoad={i <= 6}
            />
          )) }
        </SimpleSlider>
      ) : (
        <div className='SimpleSlider-spinnerWrapper'>
          <Spinner className='SimpleSlider-spinner' />
        </div>
      )}
    </Fragment>
  )
}

TrendingSlider.propTypes = {
  listings: PropTypes.array,
  markListingAsSaved: PropTypes.func,
  isLoading: PropTypes.bool
}

export default TrendingSlider
